/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.19",
    versionName: "0.2.0-nightly.2025.8.19",
    versionChannel: "nightly",
    buildDate: "2025-08-19T00:07:28.570Z",
    commitHash: "1b6c9d2fe55d8fe168668f424d8004f294752ae2",
};
